/* eslint-disable react/prop-types */
import React from 'react';
import ReactApexChart from 'react-apexcharts';
import { Row, Col, Card as CardWrapper, CardBody } from 'reactstrap';

export default function StackedChartCredits({ credits, chartOptions, type }) {
  return (
    <Row>
      <Col>
        <CardWrapper>
          <CardBody>
            {!credits?.chart?.isLoading ? (
              <ReactApexChart
                key={type}
                type="bar"
                height={550}
                options={chartOptions}
                series={[
                  {
                    name: `${type == 'available' ? 'Total:' : 'Gerado:'}`,
                    type: 'bar',
                    data: credits?.chart?.data?.map((i) => i?.value1),
                  },
                  {
                    name: `${type == 'available' ? 'Cashback:' : 'Disponibilizado:'}`,
                    type: 'bar',
                    data: credits?.chart?.data?.map((i) => i?.value2),
                  },
                  {
                    name: `${type == 'available' ? 'Incentivo:' : 'Expirado:'}`,
                    type: 'bar',
                    data: credits?.chart?.data?.map((i) => i?.value3),
                  },
                ]}
              />
            ) : (
              <div className="skeleton card" style={{ height: 550 }} />
            )}
          </CardBody>
        </CardWrapper>
      </Col>
    </Row>
  );
}
